/**
 * Loại đối tượng — Kết nối nền tảng số
 */
export default {
  ExcutionObject: '0', // Đối tượng phải thi hành án
  ExcutedObject: '1', // Đối tượng được thi hành án
  ExcutionPeople: '6', // ĐT phải THA, ĐT được THA
};
